"use client"

import ProductLabel from "@/components/common/ProductLabel"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { productActions } from "@/lib/redux/features/product/reduce"
import { Col, ConfigProvider, InputNumber, Row } from "antd"

const ProductQuantity = () => {
  const quantity = useAppSelector(state => state.product.quantity)
  const quantitySetting = useAppSelector(state => state.store.store_setting.data.quantity)
  const theme = useAppSelector(state => state.store.store_setting.data.theme)

  const dispatch = useAppDispatch()
  
  return (
    <>
      <Row>
        <ProductLabel
          labelSetting={quantitySetting.label}
        />
      </Row>
      <Row>
        <Col span={24}>
          <ConfigProvider
            theme={{
              token: {
                borderRadius: quantitySetting?.border_radius,
                colorText: quantitySetting.color || theme.color_text,
                fontFamily: quantitySetting.font_name || undefined
              }
            }}
          >
            <InputNumber
              min={1}
              value={quantity}
              size="large"
              controls={quantitySetting.shown_controllers}
              style={{
                width: '100%',
                height: "5rem",
                borderWidth: quantitySetting.border_width,
                borderColor: quantitySetting?.border_color,
                backgroundColor: quantitySetting.bg_color
              }}
              styles={{
                input: {
                  fontFamily: quantitySetting.font_name || undefined,
                  fontSize: `${quantitySetting.size / 10}rem` || undefined,
                  textAlign: (quantitySetting?.align as any) || 'center',
                  ...(quantitySetting.decorator === 'bold' ? {
                    fontWeight: 'bold'
                  } : {}),
                  ...(quantitySetting.decorator === 'italic' ? {
                    fontStyle: 'italic'
                  } : {}),
                  ...(quantitySetting.decorator === 'underline' ? {
                    textDecoration: 'underline'
                  } : {})
                }
              }}
              mode="spinner"
              onChange={(v) => {
                dispatch(productActions.updateQuantity(v))
              }}
            />
          </ConfigProvider>
        </Col>
      </Row>
    </>
  )
}

export default ProductQuantity